import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea166bf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formContainer" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_3 = {
  key: 1,
  class: "py-4"
}
const _hoisted_4 = { class: "text-muted mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "row align-items-end"
}
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "fs_12 text-muted mb-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "-- Select --", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = { class: "col-4" }
const _hoisted_18 = { class: "fs_12 text-muted" }
const _hoisted_19 = { class: "col-4" }
const _hoisted_20 = { class: "fs_12 text-muted" }
const _hoisted_21 = { class: "col-4" }
const _hoisted_22 = { class: "fs_12 text-muted" }
const _hoisted_23 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_24 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_25 = { class: "col-3" }
const _hoisted_26 = { class: "card p-3 text-center" }
const _hoisted_27 = { class: "fs_12 text-muted" }
const _hoisted_28 = { class: "fs_20" }
const _hoisted_29 = { class: "col-3" }
const _hoisted_30 = { class: "card p-3 text-center" }
const _hoisted_31 = { class: "fs_12 text-muted" }
const _hoisted_32 = { class: "fs_20" }
const _hoisted_33 = { class: "col-3" }
const _hoisted_34 = { class: "card p-3 text-center" }
const _hoisted_35 = { class: "fs_12 text-muted" }
const _hoisted_36 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_37 = { class: "col-3" }
const _hoisted_38 = { class: "card p-3 text-center" }
const _hoisted_39 = { class: "fs_12 text-muted" }
const _hoisted_40 = { class: "fs_20" }
const _hoisted_41 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_localized_text, {
            localizedKey: "Loading...",
            text: "Loading..."
          })
        ]))
      : (_ctx.profiles.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "No Due Diligence profile linked to this provider.",
                text: "No Due Diligence profile linked to this provider."
              })
            ]),
            (_ctx.unlinkedProfiles.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", _hoisted_7, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Link existing Due Diligence profile",
                        text: "Link existing Due Diligence profile"
                      })
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProfileId) = $event))
                    }, [
                      _hoisted_8,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unlinkedProfiles, (p) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: p.identifier,
                          value: p.identifier
                        }, _toDisplayString(p.providerEmail) + " - " + _toDisplayString(_ctx.getStatusLabel(p.status)) + _toDisplayString(p.companyLegalName ? ' - ' + p.companyLegalName : ''), 9, _hoisted_9))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedProfileId]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      disabled: !_ctx.selectedProfileId,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.linkProfile()))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Link",
                        text: "Link"
                      })
                    ], 8, _hoisted_11)
                  ])
                ]))
              : (!_ctx.loadingUnlinked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No unlinked Due Diligence profiles available.",
                      text: "No unlinked Due Diligence profiles available."
                    })
                  ]))
                : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profiles, (profile, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: profile.identifier,
                class: _normalizeClass(["mb-4", {'border-top pt-4': idx > 0}])
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(profile.company.text), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ms-2 badge", _ctx.getStatusBadge(profile.status)])
                    }, _toDisplayString(_ctx.getStatusLabel(profile.status)), 3)
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-tertiary",
                    onClick: ($event: any) => (_ctx.viewDetail(profile))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "View Detail",
                      text: "View Detail"
                    })
                  ], 8, _hoisted_15)
                ]),
                (profile.status >= 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Company Legal Name",
                            text: "Company Legal Name"
                          })
                        ]),
                        _createElementVNode("p", null, _toDisplayString(profile.companyLegalName || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("label", _hoisted_20, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "ESG Contact",
                            text: "ESG Contact"
                          })
                        ]),
                        _createElementVNode("p", null, _toDisplayString(profile.esgContactPerson?.name || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Invited By",
                            text: "Invited By"
                          })
                        ]),
                        _createElementVNode("p", null, _toDisplayString(profile.invitedBy?.email || '-'), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.details[profile.identifier])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_ctx.details[profile.identifier].hasSurvey)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("span", _hoisted_27, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Gross Score",
                                    text: "Gross Score"
                                  })
                                ]),
                                _createElementVNode("strong", _hoisted_28, _toDisplayString(_ctx.details[profile.identifier].grossScore?.toFixed(1) ?? '-'), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("span", _hoisted_31, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Adjusted Score",
                                    text: "Adjusted Score"
                                  })
                                ]),
                                _createElementVNode("strong", _hoisted_32, _toDisplayString(_ctx.details[profile.identifier].adjustedNetScore?.toFixed(1) ?? '-'), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("span", _hoisted_35, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Risk Level",
                                    text: "Risk Level"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("strong", {
                                    class: _normalizeClass(["fs_20", _ctx.getRiskLevelClass(_ctx.details[profile.identifier].riskLevel)])
                                  }, _toDisplayString(_ctx.getRiskLevelLabel(_ctx.details[profile.identifier].riskLevel)), 3),
                                  _createElementVNode("span", {
                                    class: "infoIcon pointer ms-2",
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showRiskLevelLegend()), ["stop"])),
                                    title: "Risk level legend"
                                  }, "ⓘ")
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("span", _hoisted_39, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Red Flags",
                                    text: "Red Flags"
                                  })
                                ]),
                                _createElementVNode("strong", _hoisted_40, _toDisplayString(_ctx.details[profile.identifier].surveyResponse?.highRedFlagsCount ?? 0) + " / " + _toDisplayString(_ctx.details[profile.identifier].surveyResponse?.redFlagsCount ?? 0), 1)
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Survey not yet completed.",
                              text: "Survey not yet completed."
                            })
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]))
  ]))
}